var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLanguages(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20805 3.48657H20.7923C21.2379 3.48657 21.6 3.84648 21.6 4.29209V17.3325C21.6 17.7781 21.2379 18.1401 20.7923 18.1401H14.1104L12.6536 20.1775C12.3322 20.6252 11.666 20.6252 11.3468 20.1775L9.88999 18.1401H3.20805C2.76245 18.1401 2.40039 17.7781 2.40039 17.3325V4.29423C2.40039 3.84863 2.76245 3.48657 3.20805 3.48657Z",
    fill: "url(#paint0_linear_1584_67841)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9205 13.0864V11.6842H7.5238V10.5606H10.4258V9.15838H7.5238V8.08874H10.9205V6.68652H5.6001V13.0864H10.9205Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3998 13.0864V6.68652H16.4761V9.90443L13.9698 6.68652H12.288V13.0864H14.2117V9.86848L16.718 13.0864H18.3998Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1584_67841",
    x1: 12.0002,
    y1: 3.48657,
    x2: 12.0002,
    y2: 20.5133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85C741"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45790F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguages);
export default __webpack_public_path__ + "static/media/languages.3903fdcd8071baf52635db54334c01d3.svg";
export { ForwardRef as ReactComponent };